import SnapSlider from '@tannerhodges/snap-slider';
import smoothscroll from 'smoothscroll-polyfill';

    smoothscroll.polyfill();

    window.addEventListener('DOMContentLoaded', () => {
      if (window.innerWidth > 1310) {
        var leftMarginTopLive = window.innerWidth / 2 - 655;
        document.getElementById('rcp_slider_container').style.marginLeft =
          leftMarginTopLive + 'px';
      } else {
        document.getElementById('rcp_slider_container').style.marginLeft =
          'auto';
      }

      window.addEventListener('resize', function () {
        if (window.innerWidth > 1310) {
          var leftMarginTopLive = window.innerWidth / 2 - 655;
          document.getElementById('rcp_slider_container').style.marginLeft =
            leftMarginTopLive + 'px';
        } else {
          document.getElementById('rcp_slider_container').style.marginLeft =
            'auto';
        }
      });

      var ctaOptions = document.getElementsByClassName('cta-rct-option');

      for (var j = 0; j < ctaOptions.length; j++) {
        var idMonthly = ctaOptions[j].getAttribute('data-id-monthly');
        var idYearly = ctaOptions[j].getAttribute('data-id-yearly');

        ctaOptions[j].addEventListener('click', function (e) {
          var idquarter = e.target.getAttribute('data-id-monthly');
          var idyear = e.target.getAttribute('data-id-yearly');

          if (
            document
              .getElementById('rcp_slider_container')
              .classList.contains('monthly-active')
          ) {
            let radios = document.getElementsByName('input_7');
            let value = idquarter;
            for (let i = 0, length = radios.length; i < length; i++) {
              if (radios[i].value == value) {
                radios[i].checked = true;
                // only one radio can be logically checked, don't check the rest
                break;
              }
            }
          } else {
            let radios = document.getElementsByName('input_7');
            let value = idyear;

            for (let i = 0, length = radios.length; i < length; i++) {
              if (radios[i].value == value) {
                radios[i].checked = true;
                // only one radio can be logically checked, don't check the rest
                break;
              }
            }
          }

          document
            .getElementsByClassName('page__body')[0]
            .scrollIntoView({ behavior: 'smooth' });
        });
      }

    });
